<template>
  <div>
    <b-alert v-for="(error, index) in errors" :key="index" show variant="danger">
      {{ error }}
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true,
    },
  },
};
</script>
